(function () {
  if (window.__cshowcaseInit) return;
  window.__cshowcaseInit = true;

  function getActiveCarousel(section) {
    if (!section) return null;
    var panel = section.querySelector('.tabs__panel:not([hidden])') || section;
    return panel.querySelector('carousel-slider');
  }

  function updateArrows(section) {
    if (!section) return;
    var prev = section.querySelector('[data-cshowcase-nav="prev"]');
    var next = section.querySelector('[data-cshowcase-nav="next"]');
    if (!prev || !next) return;

    var carousel = getActiveCarousel(section);
    var swiper = carousel && carousel.swiperInstance;

    if (!swiper || swiper.destroyed || swiper.params && swiper.params.loop) {
      prev.disabled = false;
      next.disabled = false;
      return;
    }
    prev.disabled = !!swiper.isBeginning;
    next.disabled = !!swiper.isEnd;
  }

  function openQuickView(button) {
    var card = button.closest('.cshowcase-card');
    var section = button.closest('.cshowcase');
    if (!card || !section) return;

    var template = card.querySelector('[data-cshowcase-qv-data]');
    var dialog = section.querySelector('.cshowcase__qv-dialog');
    var body = dialog && dialog.querySelector('[data-cshowcase-qv-body]');
    if (!template || !dialog || !body) return;

    body.innerHTML = '';
    body.appendChild(template.content.cloneNode(true));

    var firstThumb = body.querySelector('[data-cshowcase-qv-thumb]');
    if (firstThumb) firstThumb.classList.add('is-active');

    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  function closeQuickView(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
    var body = dialog.querySelector('[data-cshowcase-qv-body]');
    if (body) body.innerHTML = '';
  }

  function swapMainImage(thumb) {
    var gallery = thumb.closest('.cshowcase-qv');
    if (!gallery) return;
    var main = gallery.querySelector('.cshowcase-qv__main-img');
    var src = thumb.getAttribute('data-src');
    if (main && src) {
      main.src = src;
      var srcset = thumb.getAttribute('data-srcset');
      if (srcset) main.srcset = srcset;
    }
    gallery.querySelectorAll('[data-cshowcase-qv-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', t === thumb);
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var qvButton = target.closest('[data-cshowcase-qv]');
    if (qvButton) {
      event.preventDefault();
      event.stopPropagation();
      openQuickView(qvButton);
      return;
    }

    var thumb = target.closest('[data-cshowcase-qv-thumb]');
    if (thumb) {
      event.preventDefault();
      swapMainImage(thumb);
      return;
    }

    var closeButton = target.closest('[data-cshowcase-qv-close]');
    if (closeButton) {
      event.preventDefault();
      closeQuickView(closeButton.closest('.cshowcase__qv-dialog'));
      return;
    }

    if (target.classList && target.classList.contains('cshowcase__qv-dialog')) {
      closeQuickView(target);
      return;
    }

    var navButton = target.closest('[data-cshowcase-nav]');
    if (navButton) {
      event.preventDefault();
      var section = navButton.closest('.cshowcase');
      var carousel = getActiveCarousel(section);
      var swiper = carousel && carousel.swiperInstance;
      if (swiper && !swiper.destroyed) {
        if (navButton.getAttribute('data-cshowcase-nav') === 'next') {
          swiper.slideNext();
        } else {
          swiper.slidePrev();
        }
        window.setTimeout(function () {
          updateArrows(section);
        }, 50);
      }
      return;
    }
  });

  document.addEventListener('cancel', function (event) {
    var dialog = event.target;
    if (dialog instanceof Element && dialog.classList.contains('cshowcase__qv-dialog')) {
      var body = dialog.querySelector('[data-cshowcase-qv-body]');
      if (body) body.innerHTML = '';
    }
  });

  function initArrows() {
    document.querySelectorAll('.cshowcase').forEach(function (section) {
      updateArrows(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.setTimeout(initArrows, 300);
    });
  } else {
    window.setTimeout(initArrows, 300);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.querySelector ? event.target.querySelector('.cshowcase') : null;
    if (section) window.setTimeout(function () { updateArrows(section); }, 300);
  });
})();
